import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, map, Observable, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../core/services/auth/auth.service';
import { MessagePopupComponent } from '../../../shared/components/message-popup/message-popup.component';
import { PopupService } from '../../../core/../core/services/popup/popup.service';

@Injectable({
	providedIn: 'root'
})

export class ReprogrammingService {

	private url = environment.do_services_sb_url;
	private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
	private mptPriceUrl = 'tokenOffer/getMptPrice';
	private getClipSubOfferUrl = 'clip/getClipSubscriptionOffers';
	private getAdtSubOfferUrl = 'adt/getAdtSubscriptionOffers';
	private getClipAdtSubOfferUrl = 'clipAdt/getClipAdtSubscriptionOffers';
	private getClipSubscriptionUrl = 'clip/getUsersClipSubscriptionPurchaseStatus';
	private getAdtSubscriptionUrl = 'adt/getUsersAdtSubscriptionPurchaseStatus';
	private getClipAdtSubscriptionUrl = 'clipAdt/getUsersClipAdtSubscriptionPurchaseStatus';
	private getUserDetailsUrl = 'userDetails/validUser';
	private editProfileUrl = 'userDetails/updateDeliveryDetails';
	private getModuleDetailsUrl = 'tokenOffer/getModuleUrl';
	private createVciOrderUrl = 'vci/createVciOrder';

	constructor(private http: HttpClient, private authService: AuthService,
				private popupService: PopupService, private route: Router) { }

	getModuleDetails(): Observable<any> {
		return this.http.get(this.url + this.getModuleDetailsUrl, { responseType: 'text' })
			.pipe(
				map((response: any) => {
					const run = response;
					return run;
				}),
				catchError((e: any) => this.handleError(e))
			);
	}

	getMPTPrice(): Observable<any> {
		return this.http.get(this.url + this.mptPriceUrl, { responseType: 'text' })
			.pipe(
				map((response: any) => {
					const run = response;
					return run;
				}),
				catchError((e: any) => this.handleError(e))
			);
	}

	getUserDetails(userData: string): Observable<any> {
		const options = {
			headers: this.headers
		};
		return this.http.post(this.url + this.getUserDetailsUrl, userData, options)
			.pipe(
				map((response: any) => {
					const run = response;
					return run;
				}),
				catchError((e: any) => this.handleError(e))
			);
	}

	createVciOrder(userVciData: string): Observable<any> {
		const options = {
			headers: this.headers,
			responseType: 'text' as const
		};
		return this.http.post(this.url + this.createVciOrderUrl, userVciData, options)
			.pipe(
				map((response: any) => {
					const run = response;
					return run;
				}),
				catchError((e: any) => this.handleError(e))
			);
	}

	updateUserDetails(profileDeliveryInfo: string): Observable<any> {
		const options = {
			headers: this.headers
		};
		return this.http.put(this.url + this.editProfileUrl, profileDeliveryInfo, options)
			.pipe(
				map((response: any) => {
					const run = response;
					return run;
				}),
				catchError((e: any) => this.handleError(e))
			);
	}

	getClipSubOffers(): Observable<any> {
		return this.http.get(this.url + this.getClipSubOfferUrl, { responseType: 'text' })
			.pipe(
				map((response: any) => {
					const run = response;
					return run;
				}),
				catchError((e: any) => this.handleError(e))
			);
	}

	getAdtSubOffers(): Observable<any> {
		return this.http.get(this.url + this.getAdtSubOfferUrl, { responseType: 'text' })
			.pipe(
				map((response: any) => {
					const run = response;
					return run;
				}),
				catchError((e: any) => this.handleError(e))
			);
	}

	getClipAdtSubOffers(): Observable<any> {
		return this.http.get(this.url + this.getClipAdtSubOfferUrl, { responseType: 'text' })
			.pipe(
				map((response: any) => {
					const run = response;
					return run;
				}),
				catchError((e: any) => this.handleError(e))
			);
	}

	getClipSubscriptionList(): Observable<any> {
		return this.http.get(this.url + this.getClipSubscriptionUrl, { responseType: 'text' })
			.pipe(
				map((response: any) => {
					const run = response;
					return run;
				}),
				catchError((e: any) => this.handleError(e))
			);
	}

	getAdtSubscriptionList(): Observable<any> {
		return this.http.get(this.url + this.getAdtSubscriptionUrl, { responseType: 'text' })
			.pipe(
				map((response: any) => {
					const run = response;
					return run;
				}),
				catchError((e: any) => this.handleError(e))
			);
	}

	getClipAdtSubscriptionList(): Observable<any> {
		return this.http.get(this.url + this.getClipAdtSubscriptionUrl, { responseType: 'text' })
			.pipe(
				map((response: any) => {
					const run = response;
					return run;
				}),
				catchError((e: any) => this.handleError(e))
			);
	}

	private handleError(error: any): Observable<never> {
        if([400, 403, 404, 405, 500, 502, 503, 504].includes(error.status)) {
            return throwError(() => error);
        }
        if(error.status === 401) {
			const dialogRef = this.popupService.openDialog(MessagePopupComponent, {
				data: { message: 'Unauthorized Request - Your Session has expired' }
			});
			dialogRef.afterClosed().subscribe(() => {
				this.authService.logout().subscribe(() => {
					this.route.navigate(['/home']);
				});
			});
			return throwError(() => new Error('Unauthorized Request - Session expired'));
		}
        return throwError(() => new Error(`Unhandled status code: ${error.status}`));
    }
	
}